import { SUPPORTED_LANGS } from "./locale/detectLangFromPath";

export const STORE_SLUG_MAX_LENGTH = 20;

// Primeiros segmentos de URL que não podem ser slug de loja: rotas do StoreRoutes,
// caminhos usados em links do app, idiomas e caminhos servidos direto pelo nginx.
const RESERVED_STORE_SLUGS = [
  ...SUPPORTED_LANGS,
  "areamanager",
  "assets",
  "benefits",
  "businesspartner",
  "cart",
  "cart-fringe-benefit",
  "categories",
  "comingsoon",
  "confimeaconfirmation",
  "confimeaimprese",
  "customer",
  "emailconfirmation",
  "empresas",
  "extracoinstatement",
  "federnet-handoff",
  "fringe-benefit",
  "fringe-benefits",
  "landing",
  "listbrands",
  "listcategory",
  "listsubcategories",
  "listtypes",
  "login",
  "manager",
  "orderconfirmation",
  "partner",
  "planos",
  "privacy",
  "product",
  "products",
  "promoter",
  "requestpasswordchange",
  "salepromoter",
  "seller",
  "sellerprofile",
  "shop",
  "sobre",
  "specialcustomer",
  "static",
  "status",
  "store",
  "storeprofile",
  "storeregister",
  "terms",
  "white-label",
];

/**
 * Formata o slug enquanto o usuário digita: só letras minúsculas e números.
 */
export function normalizeStoreSlug(value) {
  return (value ?? "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase()
    .slice(0, STORE_SLUG_MAX_LENGTH);
}

/**
 * Indica se o slug colide com uma rota do app (o dashboard inteiro vive em "/dashboard*").
 */
export function isReservedStoreSlug(slug) {
  const value = (slug ?? "").trim().toLowerCase();
  return value.startsWith("dashboard") || RESERVED_STORE_SLUGS.includes(value);
}
